import React, { useEffect, useRef, useState } from 'react';

/** Non e' un valore in tabella: e' l'assenza della riga, cioe' "qui non decido io". */
export const EREDITATO = 'EREDITATO';

/** La griglia ha undici colonne: nel badge ci sta una lettera, il resto va nel titolo. */
const SIGLE = {
  NEGATO: 'N',
  LETTURA: 'L',
  SCRITTURA_CHECK: 'C',
  SCRITTURA: 'S'
};

const ETICHETTE = {
  NEGATO: 'negato',
  LETTURA: 'lettura',
  SCRITTURA_CHECK: 'scrittura con check',
  SCRITTURA: 'scrittura'
};

/**
 * Una cella della griglia: un badge che al clic apre il menu dei valori.
 *
 * Il badge dice tre cose diverse. Senza modifiche in sospeso mostra il livello che il server ha
 * risolto, pieno se la cella e' esplicita e tenue se ereditata, con la provenienza nel titolo. Con
 * una modifica in sospeso mostra il livello scelto. Se la modifica e' "torna a ereditare", quale
 * livello ne uscira' non lo sa nessuno prima di salvare, e allora mostra un trattino invece di
 * indovinare.
 */
const CellaPermesso = ({ risorsa, effettivo, scelto, livelli, massimo, bypassAttore, modificabile, onScegli }) => {
  const [aperto, setAperto] = useState(false);
  const contenitore = useRef(null);

  // Un menu aperto si chiude cliccando altrove: senza questo ne restano aperti undici per riga.
  useEffect(() => {
    if (!aperto) return undefined;
    const fuori = (evento) => {
      if (!contenitore.current?.contains(evento.target)) setAperto(false);
    };
    document.addEventListener('mousedown', fuori);
    return () => document.removeEventListener('mousedown', fuori);
  }, [aperto]);

  const cambiata = scelto !== undefined;
  const livello = cambiata
    ? (scelto === EREDITATO ? null : scelto)
    : (effettivo?.livello ?? 'NEGATO');
  const esplicito = cambiata ? scelto !== EREDITATO : !!effettivo?.esplicito;
  const attuale = effettivo?.esplicito ? effettivo.livello : EREDITATO;

  const titolo = cambiata
    ? `${risorsa}: da salvare, ${scelto === EREDITATO ? 'torna a ereditare' : ETICHETTE[scelto] ?? scelto}`
    : `${risorsa}: ${effettivo?.livello ?? 'NEGATO'}, ${effettivo?.da ?? 'nessuna riga'}`;

  const classi = [
    'permessi-cella',
    `permessi-${(livello ?? 'eredita').toLowerCase()}`,
    esplicito ? 'permessi-esplicita' : 'permessi-ereditata',
    cambiata ? 'permessi-in-sospeso' : ''
  ].filter(Boolean).join(' ');

  return (
    <div className="permessi-cella-wrap" ref={contenitore}>
      <button type="button" className={classi} title={titolo} disabled={!modificabile}
              onClick={() => setAperto(a => !a)}>
        {livello === null ? '-' : SIGLE[livello] ?? '?'}
        {!modificabile && <i className="fas fa-lock permessi-lucchetto"></i>}
      </button>

      {aperto && (
        <div className="permessi-menu" role="menu">
          {[EREDITATO, ...livelli].map(valore => {
            // Le opzioni che chi guarda non puo' concedere restano visibili ma spente, col motivo
            // nel titolo: il limite si vede prima di sbatterci contro.
            const troppo = valore !== EREDITATO && !bypassAttore
                        && livelli.indexOf(valore) > livelli.indexOf(massimo);

            return (
              <button type="button" key={valore} role="menuitem" disabled={troppo}
                      className={valore === (cambiata ? scelto : attuale) ? 'attiva' : ''}
                      title={troppo ? `Qui tu hai ${massimo}: non puoi concedere ${valore}` : ''}
                      onClick={() => { onScegli(valore); setAperto(false); }}>
                {valore === EREDITATO ? 'ereditato' : ETICHETTE[valore] ?? valore}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CellaPermesso;
